import { useContext } from "react";

import { SignupContext, SignUpFlowStepType } from "../contexts/SignupContext";

export let SignupFlowStep: {
  EmailStep: SignUpFlowStepType;
  AboutStep: SignUpFlowStepType;
  SignInStep: SignUpFlowStepType;
  ForgotPasswordStep: SignUpFlowStepType;
  MagicLinkSendStep: SignUpFlowStepType;
  SignupDetails: SignUpFlowStepType;
  BuyerCreationStep: SignUpFlowStepType;
  BusinessSelectStep: SignUpFlowStepType;
  ConfirmationStep: SignUpFlowStepType;
  OptInMarketingStep: SignUpFlowStepType;
  CreditEligibleStep: SignUpFlowStepType;
} = {
  EmailStep: {
    name: "EmailStep",
    currentStepIndex: undefined,
    dismiss: true,
  },
  AboutStep: {
    name: "AboutStep",
    currentStepIndex: 1,
    backStep: "EmailStep",
  },
  SignInStep: {
    name: "SignInStep",
    currentStepIndex: 2,
    backStep: "EmailStep",
  },
  ForgotPasswordStep: {
    name: "ForgotPasswordStep",
    backStep: "SignInStep",
  },
  MagicLinkSendStep: {
    name: "MagicLinkSendStep",
    currentStepIndex: 2,
    backStep: "EmailStep",
  },
  SignupDetails: {
    name: "SignupDetails",
    currentStepIndex: 3,
  },
  BusinessSelectStep: {
    name: "BusinessSelectStep",
    currentStepIndex: 3,
  },
  BuyerCreationStep: {
    name: "BuyerCreationStep",
    currentStepIndex: 4,
  },
  OptInMarketingStep: {
    name: "OptInMarketingStep",
    currentStepIndex: 5,
  },
  ConfirmationStep: {
    name: "ConfirmationStep",
  },
  CreditEligibleStep: {
    name: "CreditEligibleStep",
  },
};

export const useSignupContext = () => {
  const context = useContext(SignupContext);
  if (context === undefined) {
    throw new Error("useSignupContext must be within SignupContextProvider");
  }
  return context;
};
